import { DropdownHelperModel } from "../helpers/dropdown-helper.model";

export class UserProfileModel {   
    public adminId :string;
    public firstName : string='';
    public lastName : string='';
    public roleName : string;
    public profilePictureUrl : string;
    public email : string='';
    public companyId : string='';
    public phone : string='';
    public dateOfBirth : any;
}